module.exports = __webpack_public_path__ + "img/pq_element-06_nav.f871a9f9.png";